import clsx from 'clsx'
import { Col, CreateTableState, Grid, Typography } from 'gu-ui-kit'
import i18n from 'i18next'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Services/Access/List/network-account-access.module.scss'
import { DeleteButton, StatusBadge } from 'modules/Services/Access/List/subcomponents/index'
import { useTranslation } from 'react-i18next'
import { notificationShow } from 'modules/Notifications/actions'
import { ACCESS_DELETE } from 'modules/Services/types'
import UserIcon from 'modules/Services/Access/List/subcomponents/UserIcon'

export const vk = ({ filters, processingIds, networkType, accountId }, data) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()
  const archiveView = useMemo(() => filters.status?.value === 'archived', [filters])
  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.sm:
        setColumnVisibility({ is_new: false, view: false, role: false })
        break
      case breakpoints.mds:
        setColumnVisibility({ is_new: false })
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  const tableConfig = {
    columns: [
      {
        id: 'external_id',
        header: t('services::accesses.table.head.name'),
        className: clsx(styles['accesses-list__cell'], styles['accesses-list__cell_name'], {
          [styles['accesses-list__cell_name-archived']]: archiveView,
        }),
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              role,
              // eslint-disable-next-line react/prop-types
              external_user_id,
            },
          },
        }) => (
          <div className={styles['accesses-list__col-layout']}>
            <Grid wrap={'nowrap'} justifyContent="start" alignItems="center">
              <UserIcon />
              <Grid
                fluid={false}
                direction="column"
                alignItems="start"
                justifyContent="start"
                gap={4}
              >
                <Typography variant={'Body-20'} noMargin color={'inherit'}>
                  ID: {external_user_id}
                </Typography>

                {breakpoints.sm && (
                  <StatusBadge
                    label={i18n.t(`services::accesses.roles.options.${role}`)}
                    status={role}
                    className={styles['accesses-list__status']}
                  />
                )}
              </Grid>
            </Grid>
          </div>
        ),
      },
      {
        id: 'role',
        header: t('services::accesses.table.head.role'),
        className: clsx(styles['accesses-list__cell'], styles['accesses-list__cell_access-type']),
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              role, // eslint-disable-next-line react/prop-types
            },
          },
        }) => {
          return (
            <div className={styles['accesses-list__col-layout']}>
              <Grid
                alignItems="start"
                justifyContent="start"
                direction="column"
                l={{
                  direction: 'row',
                  alignItems: 'center',
                  justifyContent: 'between',
                }}
              >
                <Col>
                  {!breakpoints.sm && (
                    <StatusBadge
                      label={i18n.t(`services::accesses.roles.options.${role}`)}
                      status={role}
                      className={styles['accesses-list__status']}
                    />
                  )}
                </Col>
              </Grid>
            </div>
          )
        },
      },
      {
        id: 'actions',
        header: ' ',
        className: clsx(styles['accesses-list__cell'], styles['accesses-list__cell_actions']),
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              id, // eslint-disable-next-line react/prop-types
              name, // eslint-disable-next-line react/prop-types
            },
          },
        }) => {
          return (
            <div className={styles['accesses-list__col-layout']}>
              <Grid alignItems="flex-end" justifyContent="flex-end" direction="column">
                <DeleteButton
                  className={styles['accesses-list__action-icon-button']}
                  onClick={() =>
                    new Promise((resolve, reject) =>
                      dispatch({
                        type: ACCESS_DELETE,
                        meta: { resolve, reject },
                        payload: {
                          accountId,
                          accessId: id,
                          action: 'delete',
                          networkType,
                        },
                      }),
                    ).then((response) => {
                      const message = response?.data?.ticket_id
                        ? t('services::accesses.notifications.ticket_created', {
                            ticket_id: response.data.ticket_id,
                          })
                        : t('common::notifications.success_removed')

                      dispatch(
                        notificationShow({
                          type: 'success',
                          message,
                          delay: 5000,
                        }),
                      )
                    })
                  }
                  login={name}
                  processing={processingIds.includes(id)}
                />
              </Grid>
            </div>
          )
        },
      },
    ],
    data,
    state: {
      columnVisibility: archiveView
        ? { is_new: false, ...columnVisibility }
        : { ...columnVisibility },
    },
    className: styles['accesses-list__table'],
    showFooter: false,
  }

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
